import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fd1d6da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brush-map__select-color" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "brush-map__title" }, "3. Выберите цвет ёршика", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle brush-map__subtitle_grey" }, [
  /*#__PURE__*/_createTextVNode(" Нажмите на нужный Вам цвет ёршика "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" и окрасьте нужное место. ")
], -1))
const _hoisted_4 = { class: "brush-map__current-color" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Текущий цвет:", -1))

import { computed } from 'vue'
import FirmCuraprox from './FirmColors/FirmCuraprox.vue'
import FirmCurasept from './FirmColors/FirmCurasept.vue'
import FirmTepe from './FirmColors/FirmTepe.vue'
import FirmInterprox from './FirmColors/FirmInterprox.vue'
import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { BrushMapTeeth } from '@/pages/BrushMapPage/brushMapTeeth'
import { BrushMapFirm } from '@/pages/BrushMapPage/brushMapFirm'

interface Props {
  brushMapTeeth: BrushMapTeeth
  brushMapBrushes: BrushMapAddedBrushes
  brushMapFirm: BrushMapFirm
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapTeeth: null,
    brushMapBrushes: null,
    brushMapFirm: null
  },
  setup(__props: any) {

const props = __props as {
  brushMapTeeth: BrushMapTeeth
  brushMapBrushes: BrushMapAddedBrushes
  brushMapFirm: BrushMapFirm
}



const computeComponent = computed(() => {
  const nameFirm = props.brushMapFirm.firm.nameFirm

  switch (nameFirm) {
    case 'Curaprox':
      return FirmCuraprox
    case 'Curasept':
      return FirmCurasept
    case 'Interprox':
      return FirmInterprox
    case 'TePe':
      return FirmTepe
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(computeComponent)), {
        "brush-map-controller": __props.brushMapTeeth,
        brushMapBrushes: __props.brushMapBrushes
      }, null, 8, ["brush-map-controller", "brushMapBrushes"]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", {
        style: _normalizeStyle({ background: __props.brushMapBrushes.selectedBrush.color })
      }, null, 4),
      _createElementVNode("p", null, _toDisplayString(__props.brushMapBrushes.selectedBrush.colorName), 1)
    ])
  ], 64))
}
}

})